import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  class: "v-icon__svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10 .5a9.5 9.5 0 1 1 0 19 9.5 9.5 0 0 1 0-19"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#525252",
      d: "M10 .5a9.5 9.5 0 1 1 0 19 9.5 9.5 0 0 1 0-19Z"
    }, null, -1)
  ])))
}
export default { render: render }